import { useMemo } from "react";
import { useFormik } from "formik";

import classes from "./styles.module.scss";

import type { ITableSearchProps } from "@components/molecules/tableSearch/types";
import { SearchFormConfig } from "@components/molecules/tableSearch/schema";
import { SearchInput } from "@/components/formControls";

export function TableSearch({
  value,
  onChange,
  placeholder,
}: ITableSearchProps) {
  const formConfig = useMemo(() => {
    return SearchFormConfig();
  }, []);

  const formik = useFormik({
    ...formConfig,
    initialValues: { search: value || formConfig?.initialValues?.search },
    enableReinitialize: true,
  });

  return (
    <form className={classes.search}>
      <SearchInput
        value={formik.values.search}
        onChange={(value) => {
          formik.setFieldValue("search", value);
        }}
        onDebouncedValueChange={(value) => {
          onChange(value);
        }}
        readOnly={false}
        placeholder={placeholder}
      />
    </form>
  );
}
